import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { useGeneralStore } from '../stores/general'
import { useAuthStore } from '../stores/auth'
import { useStorage } from "@vueuse/core";

const apiClient: AxiosInstance = axios.create({
    headers: {
        'Content-type': 'application/ld+json'
    }
})
const tokenStorage = useStorage('lernleitstand-store-token', '')
const switchUserStorage = useStorage('switch-user', '')


const switchUser = switchUserStorage.value
const token = tokenStorage.value

if (token && token.length > 10) {
    axios.defaults.headers.common = { Authorization: `Bearer ${token}` }
    if (switchUser) {
        axios.defaults.headers.common['-SWITCH-USER'] = switchUser
    }
} else {
    tokenStorage.value = ''
}

apiClient.interceptors.request.use(
    (
        config: InternalAxiosRequestConfig
    ): InternalAxiosRequestConfig<any> | Promise<InternalAxiosRequestConfig<any>> => {
        const generalStore = useGeneralStore()
        const authStore = useAuthStore()
        const switchUserStorage = useStorage('switch-user', '')


        const switchUser = switchUserStorage.value
        const token = authStore.getToken

        config.baseURL = generalStore.getApiUrl
        if (token && token.length > 10) {
            config.headers['Authorization'] = `Bearer ${token}`
            if (switchUser) {
                config.headers['-SWITCH-USER'] = switchUser
            }
        } else {
            config.headers['Authorization'] = ``
        }

        return config
    }
)

export default apiClient
